import {
    columnVisibilityFeature,
    createSortedRowModel,
    metaHelper,
    rowPaginationFeature,
    rowSortingFeature,
    sortFns,
    tableFeatures,
} from "@tanstack/react-table";

export type AppColumnMeta = {
    getCellContext: (context: unknown) => {
        length?: number;
        fixedWidth?: number;
        growWidth?: boolean;
    };
};

/** Client-side sorting listings (admin, orderer, unit, orders). */
export const sortingListingFeatures = tableFeatures({
    rowSortingFeature,
    columnVisibilityFeature,
    sortedRowModel: createSortedRowModel(),
    sortFns,
    columnMeta: metaHelper<AppColumnMeta>(),
});

/** Server-driven pagination (customer listing). Sorting feature keeps Table UI typed; columns disable sorting. */
export const paginatedListingFeatures = tableFeatures({
    rowPaginationFeature,
    rowSortingFeature,
    columnVisibilityFeature,
    columnMeta: metaHelper<AppColumnMeta>(),
});
